module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "specialization_form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field02"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    attrs: {
      "type": "text",
      "id": "field02"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field03"
    }
  }, [_vm._v("Код")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code),
      expression: "model.code"
    }],
    attrs: {
      "type": "number",
      "id": "field03"
    },
    domProps: {
      "value": (_vm.model.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field01"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.status),
      expression: "model.status"
    }],
    attrs: {
      "id": "field01"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "verified"
    }
  }, [_vm._v("Верифицированая")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_verified"
    }
  }, [_vm._v("Не верифицированая")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178ecd5d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin panel/forms/SpecializationForm.vue
// module id = 589
// module chunks = 0